"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageOptimizationSetting = void 0;

var getImageOptimizationSetting = function getImageOptimizationSetting(state) {
  return state.imageOptimizationSettings.get('imageOptimizationSetting');
};

exports.getImageOptimizationSetting = getImageOptimizationSetting;